/* global chartbeat */

/**
 * Trigger Chartbeat event.
 *
 * @param {string} chartbeatEvent - The name of the Chartbeat event to trigger.
 *
 * @return {void}
 */
const triggerChartbeatEvent = (chartbeatEvent) => {
  // eslint-disable-next-line no-console
  console.log(`--- Chartbeat Event - ${chartbeatEvent} ---`);
  chartbeat(chartbeatEvent);
};

/**
 * Check if the element contains a string in its class or ID.
 *
 * @param {element}         element     - The element to check.
 * @param {string|string[]} identifiers - The string, or array of strings, to look for.
 *
 * @return {boolean} - Boolean if string is found in element ID or class.
 */
const checkElementIdAndClassContainsString = (element, identifiers) => {
  // Early return if no element or string is provided
  if (!element || !identifiers) return false;

  // Convert any string matches to an array
  const identifierArray = Array.isArray(identifiers) ? identifiers : [identifiers];

  // Define the element classes and IDs to check against
  const elementClasses = element.classList;
  const elementId = element.id;

  // Loop over identifierArray
  return identifierArray.some((identifier) => {
    // Check if the classlist contains the string
    if (Array.from(elementClasses).some((className) => className.includes(identifier))) {
      return true;
    }

    // Check if the ID contains the string
    if (elementId && elementId.includes(identifier)) {
      return true;
    }

    return false;
  });
};

/**
 * Determine the social platform from the URL.
 *
 * @param {string} href - The href of the social link.
 *
 * @return {string} - The name of the social platform.
 */
const getSocialPlatformFromUrl = (href) => {
  // Lowercase for accurancy
  const url = href.toLowerCase();

  // Create map of keys and results
  const socialPlatformsMap = [
    { urlPartial: 'facebook.com', platformName: 'Facebook' },
    { urlPartial: 'twitter.com', platformName: 'Twitter' },
    { urlPartial: 'mailto:', platformName: 'Mail' },
    { urlPartial: 'pinterest.com', platformName: 'Pinterest' },
    { urlPartial: 'linkedin.com', platformName: 'Linkedin' },
    { urlPartial: 'whatsapp.com', platformName: 'Whatsapp' },
    { urlPartial: 'news.google.com', platformName: 'Google' },
  ];

  // Loop over map for matches
  for (const { urlPartial, platformName } of socialPlatformsMap) {
    if (url.includes(urlPartial)) {
      return platformName;
    }
  }
  // Return empty string if no matches
  return '';
};

// Configuration for various forms and their events
const chartbeatFormEventMap = [
  // Search forms
  { formAttribute: ['search-form', 'search-container'], eventName: 'trackSearchComplete' },
  // Newsletters
  {
    formAttribute: ['signup-form', 'form-subscribe', 'subscriptionForm', 'form-subscribe-popup'],
    eventName: 'trackNewsletterSignupComplete',
  },
];

// Submit event listener
document.addEventListener('submit', (e) => {
  // Determine the target of the submit event
  const submitElement = e.target;

  // If the element is not a form, return
  if (submitElement.tagName !== 'FORM') return;

  // Loop over the event map and trigger a chartbeat event when form matches
  chartbeatFormEventMap.some(({ formAttribute, eventName }) => {
    if (checkElementIdAndClassContainsString(submitElement, formAttribute)) {
      triggerChartbeatEvent(eventName);
      // Only trigger a single event
      return true;
    }
    return false;
  });
});

// Define the social share icons
const socialShareIcons = document.querySelectorAll('.share-content a');

// Add event triggers to the social icons
if (socialShareIcons.length) {
  socialShareIcons.forEach((icon) => {
    icon.addEventListener('click', () => {
      const socialPlatformtitle = getSocialPlatformFromUrl(icon.href);
      triggerChartbeatEvent(`track${socialPlatformtitle}SocialShare`);
    });
  });
}
